import Link from "next/link";
import Image from "next/image";
import styled from "styled-components";

import { colors } from "const/colors";
import { contactEmail } from "const/links";
import { Section, SectionLarge, Text } from "styles";

import FacebookLink from "../FacebookLink/FacebookLink";
import StoreBadges from "../StoreBadges/StoreBadges";

const FooterRoot = styled.footer`
	width: 100%;
	background: #fff;
	padding: 72px 0 40px;
	margin-top: 0;
	box-sizing: border-box;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: 1.4fr 1fr 1.2fr;
	gap: 48px;
	width: 100%;
	align-items: start;

	@media (max-width: 900px) {
		grid-template-columns: 1fr;
		gap: 36px;
		text-align: center;
		justify-items: center;
	}
`;

const Brand = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	max-width: 360px;

	@media (max-width: 900px) {
		align-items: center;
	}
`;

const LogoRow = styled(Link)`
	display: flex;
	align-items: center;
	gap: 10px;
	color: inherit;
`;

const LogoWord = styled.span`
	font-size: 28px;
	font-family: "Arial Rounded MT Bold", "Arial Rounded MT", Arial, sans-serif;
	background: -webkit-linear-gradient(45deg, #ba6bff, #2572b5);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
`;

const LinkCol = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	min-width: 160px;

	@media (max-width: 900px) {
		align-items: center;
	}
`;

const FooterLink = styled(Link)`
	color: ${colors.muted};
	font-size: 18px;

	&:hover {
		color: ${colors.blue};
	}
`;

const MailLink = styled.a`
	display: inline-flex;
	align-items: center;
	color: ${colors.blue};
	font-size: 18px;
	font-weight: 600;

	&:hover {
		color: ${colors.active};
	}
`;

const Bottom = styled.div`
	margin-top: 48px;
	padding-top: 24px;
	border-top: 1px solid ${colors.line};
	text-align: center;
`;

export default function Footer() {
	return (
		<FooterRoot id="site-footer">
			<Section>
				<SectionLarge style={{ width: "100%", flexDirection: "column" }}>
					<Grid>
						<Brand>
							<LogoRow href="/">
								<Image
									unoptimized
									src="/assets/icon/icon_rainbow.png"
									height={44}
									width={44}
									alt="Wishbox"
								/>
								<LogoWord>Wishbox</LogoWord>
							</LogoRow>
							<Text body style={{ color: colors.muted }}>
								Label savings for wishes and future expenses — on every device you already use.
							</Text>
							<Text body style={{ color: colors.muted }}>
								iPhone, iPad, Mac, and Apple Watch now. Android and Wear OS coming soon.
							</Text>
						</Brand>
						<LinkCol>
							<Text header style={{ fontSize: 20, lineHeight: "24px", marginBottom: 6 }}>
								Pages
							</Text>
							<FooterLink href="/">Home</FooterLink>
							<FooterLink href="/support">Support</FooterLink>
							<FooterLink href="/privacy">Privacy</FooterLink>
							<FooterLink href="/terms">Terms</FooterLink>
							<FooterLink href="/eula">EULA</FooterLink>
							<MailLink href={`mailto:${contactEmail}`}>{contactEmail}</MailLink>
							<FacebookLink />
						</LinkCol>
						<Brand>
							<Text header style={{ fontSize: 20, lineHeight: "24px" }}>
								Get Wishbox
							</Text>
							<StoreBadges />
						</Brand>
					</Grid>
					<Bottom>
						<Text color={colors.muted}>
							Copyright © 2022 - {new Date().getFullYear()} Kostas Filios. All rights reserved.
						</Text>
					</Bottom>
				</SectionLarge>
			</Section>
		</FooterRoot>
	);
}
